"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _errorMessage = _interopRequireDefault(require("./error-message"));
var _label = _interopRequireWildcard(require("./label"));
var _textfieldModule = _interopRequireDefault(require("./textfield.module.scss"));
var _dropdownModule = _interopRequireDefault(require("./dropdown.module.scss"));
var _field = require("./field");
var _fieldsize = _interopRequireWildcard(require("./fieldsize"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Dropdown
// ========

const Dropdown = props => {
  const renderOptions = () => props.options.map((option, i) => /*#__PURE__*/_react.default.createElement("option", (0, _extends2.default)({
    key: i
  }, option), option.label || option.value));
  const id = props.id || (0, _field.makeIdString)();
  // eslint-disable-next-line no-negated-condition
  const valueProps = props.value !== undefined ? {
    value: props.value
  } : {};
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_dropdownModule.default.Dropdown, props.classNames.wrapper)
  }, /*#__PURE__*/_react.default.createElement(_label.default, {
    className: (0, _classnames.default)(props.classNames.label, {
      [_textfieldModule.default.errorLabel]: props.errorMessage,
      [props.classNames.labelDisabled]: props.disabled
    }),
    for: id,
    tooltip: props.tooltip,
    size: props.size
  }, props.label), /*#__PURE__*/_react.default.createElement(_label.SubLabel, {
    className: (0, _classnames.default)(props.classNames.subLabel, {
      [_textfieldModule.default.errorLabel]: props.errorMessage,
      [_dropdownModule.default.labelDisabled]: props.disabled,
      [props.classNames.labelDisabled]: props.disabled
    }),
    size: props.size
  }, props.subLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: _dropdownModule.default.fieldIconContainer
  }, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({}, valueProps, {
    disabled: props.disabled,
    name: props.name,
    id: id,
    "data-test-id": props.dataTestId,
    "aria-label": props.ariaLabel,
    ref: props.innerRef,
    className: (0, _classnames.default)(_dropdownModule.default.field, {
      [_dropdownModule.default.fieldInvalid]: props.errorMessage,
      [_dropdownModule.default.selectDisabled]: props.disabled,
      [props.classNames.selectDisabled]: props.disabled,
      [_dropdownModule.default.fieldSmall]: props.size === _fieldsize.default.SMALL,
      [_dropdownModule.default.fieldDefault]: props.size === _fieldsize.default.DEFAULT
    }, props.classNames.field),
    onChange: props.onChange,
    onFocus: props.onFocus,
    onClick: props.onClick
  }), renderOptions()), /*#__PURE__*/_react.default.createElement("svg", {
    className: _dropdownModule.default.icon,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.702 4.8l1.426 1.401-5.415 5.514a1 1 0 0 1-1.426 0L1.872 6.2l1.426-1.4L8 9.587 12.702 4.8z",
    fill: "currentColor"
  }))), props.errorMessage && /*#__PURE__*/_react.default.createElement(_errorMessage.default, {
    message: props.errorMessage,
    className: props.classNames.errorMessage,
    size: props.size
  }));
};
Dropdown.propTypes = {
  ..._field.fieldPropTypes,
  ..._fieldsize.fieldSizePropTypes,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  disabled: _propTypes.default.bool,
  classNames: _propTypes.default.shape({
    wrapper: _propTypes.default.string,
    label: _propTypes.default.string,
    subLabel: _propTypes.default.string,
    field: _propTypes.default.string,
    errorMessage: _propTypes.default.string,
    labelDisabled: _propTypes.default.string,
    selectDisabled: _propTypes.default.string
  }),
  onClick: _propTypes.default.func
};
Dropdown.defaultProps = {
  disabled: false,
  classNames: {},
  ..._fieldsize.fieldSizeDefaultProps
};
var _default = exports.default = Dropdown;